import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { ResetStagedShipment } from '../../core/api/lab.types';

export const resetStagedShipmentHasErrorSelector = (state: RootState): boolean =>
  state.resetStagedShipment.errors && state.resetStagedShipment.errors ? true : false;

export const resetStagedShipmentIsBusySelector = (state: RootState): boolean =>
  state.resetStagedShipment.status === StoreStatus.BUSY;

export const resetStagedShipmentResponseSelector = (state: RootState): ResetStagedShipment | null =>
  state.resetStagedShipment.response || null;
